import styled from "@emotion/styled";

import { withShowIf } from "../../with-show-if/with-show-If.component";

export const PullRight = withShowIf(styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 1rem;
`);
